module.exports = __webpack_public_path__ + "img/flat.2d8744b9.png";